import wrapWithProvider from './wrapWithProvider';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = wrapWithProvider;
